import { useIsVisible } from '@folklore/hooks';
import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';

import Blocks from '../../components/blocks/Blocks';

import styles from '../../styles/animations/mes-quebec/card.module.css';

interface CardProps {
    className?: string | null;
    layout?: string | null;
    surtitle?: string | null;
    title?: string | null;
    blocks?: Block[] | null;
}

function Card({
    className = null,
    layout = null,
    surtitle = null,
    title = null,
    blocks = null,
    ...props
}: CardProps) {
    const { ref, visible = false } = useIsVisible({ rootMargin: '-40%', persist: false });
    const finalLayout = layout !== null ? camelCase(layout || '') : 'empty';

    return (
        <div
            className={classNames(
                styles.container,
                {
                    [styles[finalLayout]]: finalLayout !== null,
                    [styles.visible]: visible !== false,
                },
                className,
            )}
            data-layout={layout}
            ref={ref}
        >
            <div className={styles.outer}>
                <div className={styles.inner}>
                    <div className={styles.surtitle}>
                        <span>{surtitle}</span>
                    </div>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.text}>
                        {blocks !== null ? (
                            <Blocks
                                blocks={blocks}
                                className={styles.blocks}
                                blockClassName={styles.block}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Card;
